import {
  mdiMagnify,
  mdiArrowRight,
  mdiFormatListBulleted,
  mdiListBoxOutline,
  mdiPlus,
  mdiSync,
  mdiDelete,
  mdiDeleteRestore
} from '@mdi/js'

export default {
  'freshvueaudits-audit': mdiMagnify,
  'freshvueaudits-arrow-right': mdiArrowRight,

  'freshvueaudits-view-table': mdiFormatListBulleted,
  'freshvueaudits-view-expansion-panel': mdiListBoxOutline,

  'freshvueaudits-action-created': mdiPlus,
  'freshvueaudits-action-updated': mdiSync,
  'freshvueaudits-action-deleted': mdiDelete,
  'freshvueaudits-action-restored': mdiDeleteRestore
}
